import React from "react";
import { HERO } from "@/constants/testIds";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative min-h-screen w-full overflow-hidden bg-[#F9F8F6]">
      {/* Image side */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/6587896/pexels-photo-6587896.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Modern kitchen with porcelain tile floor"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F9F8F6] via-[#F9F8F6]/85 to-[#F9F8F6]/10 md:via-[#F9F8F6]/60 md:to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative container-wide min-h-screen flex flex-col justify-center pt-32 pb-24">
        <div className="max-w-3xl fade-up">
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] text-[#1A1A1A] font-light">
            Elevating South Florida spaces with
            <span className="italic text-[#8C7A6B]"> premium stone </span>
            &amp; tile.
          </h1>
          <p className="mt-8 max-w-xl text-[#5C5C5C] text-base sm:text-lg leading-relaxed">
            A curated collection of porcelain, ceramic, marble, pavers, and travertine —
            quarried, vetted, and delivered for the most discerning projects from Miami to Palm Beach.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid={HERO.ctaPrimary}
              onClick={() => scrollTo("collection")}
              className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#1A1A1A] text-[#F9F8F6] text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#3a3a3a] transition-colors"
            >
              Explore the Collection
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid={HERO.ctaSecondary}
              onClick={() => scrollTo("careers")}
              className="inline-flex items-center justify-center px-8 py-4 border border-[#1A1A1A] text-[#1A1A1A] text-xs tracking-[0.25em] uppercase font-semibold hover:bg-[#1A1A1A] hover:text-[#F9F8F6] transition-colors"
            >
              We're Hiring
            </button>
          </div>
        </div>

        {/* Decorative meta strip */}
        <div className="hidden md:flex absolute bottom-12 left-0 right-0 container-wide justify-between text-xs tracking-[0.25em] uppercase text-[#5C5C5C]">
          <span>05 Categories</span>
          <span>Miami · Ft. Lauderdale · Palm Beach</span>
          <span>Trade & Retail</span>
        </div>
      </div>
    </section>
  );
};
